import axios from "axios";

export const charityRequestService = {
  createCharityRequest: (body) =>
    axios.post("/charity_request", body, { auth: true }),
};
